import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { ModelListSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

Vue.use(VueAxios, axios)

export default Vue.component('lost-pet-search-controls', {
  props: ['isLoading'],
  components: {
    ModelListSelect,
  },
  data() {
    return {
      includeFoundPets: true,
      includeLostPets: true,
      speciesId: '',
      regionId: '',
      results: [],
      searchTerm: '',
      species: window.CANZ?.species ?? [],
      regions: window.CANZ?.regions ?? [],
    }
  },
  created: function() {
    let queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    if (queryString.length === 0) {
      this.includeFoundPets = true
      this.includeLostPets = true
      this.speciesId = ''
      this.regionId = ''
      this.searchTerm = ''
    } else {
      this.includeFoundPets = urlParams.get('found') === 'false' ? false : true
      this.includeLostPets = urlParams.get('lost') === 'false' ? false : true
      this.speciesId = urlParams.get('speciesId') ?? ''
      const regionId = urlParams.get('regionId') ?? ''
      this.regionId = regionId
      this.searchTerm = urlParams.get('st') ?? ''
      this.$emit('region-change', regionId)
    }
    this.doSearch()
  },
  methods: {
    onRegionChange(value) {
      this.$emit('region-change', value)
      this.doSearch()
    },
    doSearch() {
      this.$emit('loading-state', true)

      let path = window.location.pathname

      path = path.substring(path.length - 1) === '/' ? path : path + '/'

      const currentSearchUrl = new URLSearchParams(window.location.search)

      const loadStart = new Date().getTime()
      const searchParams = new URLSearchParams()

      searchParams.set('mode', currentSearchUrl.get('mode') ?? 'list')
      searchParams.set('lost', this.includeLostPets)
      searchParams.set('found', this.includeFoundPets)
      !!this.speciesId && searchParams.set('speciesId', this.speciesId)
      !!this.regionId && searchParams.set('regionId', this.regionId)
      !!this.searchTerm && searchParams.set('st', this.searchTerm)

      const url = new URL(window.location.href)
      url.search = searchParams.toString()
      window.history.replaceState(null, null, url.href)
      this.errorMessage = ''
      this.results = []

      const urlToUse =
        path +
        'search?lost=' +
        encodeURIComponent(this.includeLostPets) +
        '&found=' +
        encodeURIComponent(this.includeFoundPets) +
        (this.speciesId ? '&species=' + encodeURIComponent(this.speciesId) : '') +
        (this.regionId ? '&region=' + encodeURIComponent(this.regionId) : '') +
        (this.searchTerm ? '&st=' + encodeURIComponent(this.searchTerm) : '')

      this.axios({
        method: 'GET',
        url: urlToUse,
        maxRedirects: 0,
      })
        .then(res => {
          this.clearLoading(loadStart)
          if (res?.data?.status !== 'success') {
            this.errorMessage = 'An unknown error occurred, please refresh or try again later'
            this.results = []
          } else {
            this.errorMessage = ''
            this.results = (res?.data?.results || []).map(result => {
              result.menuIsOpen = false
              return result
            })
          }
          this.clearLoading(loadStart)
          this.$emit('update-results', this.results, res?.data?.markersArray ?? [])
        })
        .catch(err => {
          this.clearLoading(loadStart)
          this.errorMessage =
            err?.response?.data?.errors?.[0]?.value || 'An unknown error occurred, please refresh or try again later'
          this.results = []
        })
    },
    clearAll() {
      this.speciesId = ''
      this.regionId = ''
      this.searchTerm = ''
      this.doSearch()
    },
    // Ensures the loading state is enabled for at least 500ms to show that it did something
    clearLoading(loadStart) {
      const waitBeforeClearing = 500 - (new Date().getTime() - loadStart)
      if (waitBeforeClearing > 0) {
        window.setTimeout(() => {
          this.$emit('loading-state', false)
        }, waitBeforeClearing)
      } else {
        this.$emit('loading-state', false)
      }
    },
  },
})
